import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Clock, CheckCircle2, MessageCircle } from 'lucide-react';
import { Button } from './Button';
import { FloatingDecorations } from './FloatingDecorations';
export function FinalCta() {
  return <section className="py-24 relative overflow-hidden bg-gradient-to-b from-pastel-white to-pastel-lavender/30" data-id="element-90">
      <FloatingDecorations data-id="element-91" />

      <div className="container mx-auto px-5 sm:px-8 lg:px-12 relative z-10" data-id="element-92">
        <div className="max-w-4xl mx-auto text-center" data-id="element-93">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-94">
            <div className="inline-block bg-rose-100 text-rose-600 font-bold px-4 py-1 rounded-full text-sm mb-6 animate-pulse" data-id="element-95">
              ⚠️ Oferta especial por tiempo limitado
            </div>

            <h2 className="text-4xl md:text-6xl font-display font-bold text-gray-900 mb-8 leading-tight" data-id="element-96">
              Regalale a tu hijo una infancia más{' '}
              <span className="text-gradient from-pastel-lavender-dark to-pastel-pink" data-id="element-97">
                tranquila y feliz.
              </span>
            </h2>

            <div className="mb-10" data-id="element-98">
              <Button href="#oferta" className="w-full sm:w-auto text-xl px-12 py-5 shadow-2xl shadow-pastel-lavender-dark/30" data-id="element-99">
                QUIERO ACCEDER AHORA
              </Button>
            </div>

            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600 font-medium bg-white/60 backdrop-blur-sm py-4 px-6 rounded-2xl inline-flex border border-white" data-id="element-100">
              <div className="flex items-center gap-2" data-id="element-101">
                <Shield size={18} className="text-pastel-aqua" data-id="element-102" />
                <span data-id="element-103">Pago Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-104">
                <CheckCircle2 size={18} className="text-pastel-yellow" data-id="element-105" />
                <span data-id="element-106">Garantía 7 días</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-107">
                <Clock size={18} className="text-pastel-mint" data-id="element-108" />
                <span data-id="element-109">Acceso Inmediato</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-110">
                <MessageCircle size={18} className="text-pastel-pink" data-id="element-111" />
                <span data-id="element-112">Soporte por WhatsApp</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}